import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useWebHaptics } from "web-haptics/react";
import useLocalStorage from "./useLocalStorage";

export default function useHaptic(intensity: "light" | "medium" | "heavy" | "nudge" | "buzz" = "light") {
    const { trigger } = useWebHaptics();
    const [hapticEnabled] = useLocalStorage<boolean>("LASTDOTCARDS.HAPTIC", true);

    return React.useCallback(() => {
        if(hapticEnabled) {
            trigger(intensity);
        }
    }, [hapticEnabled, trigger, intensity]);
}
